import { DATABASE_UPDATE } from "../actions/database";
import { CURRENT_IDENTITY_ANSWER_SELECTED, CURRENT_IDENTITY_QUESTION, PAGE_TRANSITIONING, SESSION_HIDE_LOGIN, SESSION_LOGOUT, SESSION_SHOW_LOGIN } from "../actions/session";
import buildReducer from "./build-reducer";
import { fromJS } from "immutable";

let reducers = {};

reducers[CURRENT_IDENTITY_ANSWER_SELECTED] = (state, { index }) => {
  return state.setIn(["identity_verification_questions", state.get("currentIdentityQuestionIndex"), "answers", index, "selected"], true);
};

reducers[CURRENT_IDENTITY_QUESTION] = (state) =>
  state.set("currentIdentityQuestionIndex", state.get("currentIdentityQuestionIndex") + 1);

reducers[DATABASE_UPDATE] = (state, { tables: { session } }) => {
  return state
    .merge(fromJS(session));
};

reducers[PAGE_TRANSITIONING] = (state) =>
  state.remove("showLogin");

reducers[SESSION_HIDE_LOGIN] = (state) =>
  state.remove("showLogin");

reducers[SESSION_SHOW_LOGIN] = (state) =>
  state.set("showLogin", true);

reducers[SESSION_LOGOUT] = (state) =>
  state.clear().merge(defaultSession);

const defaultSession = fromJS({
  currentIdentityQuestionIndex: 0,
  abilities: [
    "enter cash contests",
    "enter player pools",
    "enter qualifier contests"
  ]
});
export default buildReducer(defaultSession, reducers);
